class InterfaceConstructor {
    constructor(name) {
        this.name = name
        this.methods = {}
    }
    get(methodName) {
        return this.methods[methodName]
    }
    set(methodName, callback) {
        this.methods[methodName] = callback
    }
    hasSupport(methodName) {
        return this.methods.hasOwnProperty(methodName)
    }
}

module.exports = InterfaceConstructor
